// ============================================================
// TASK HYDRATOR
//
// Translates database objects into BluPrint objects.
//
// Database names remain here.
// The UI should consume BluPrint names only.
// ============================================================

import {
  relation,
  flag,
  exists
} from './common'

/**
 * Converts a raw Supabase task into the BluPrint Task object.
 */
export function hydrateTask(task) {

  // ----------------------------------------------------------
  // Primary relationships
  // ----------------------------------------------------------

  const project = relation(task.projects)
  const priority = relation(task.priority_levels)
  const status = relation(task.status_levels)
  const context = relation(task.context)
  const focusArea = relation(task.focus_area)
  const location = relation(task.locations)
  const taskTime = relation(task.task_times)
  const timeOfDay = relation(task.time_of_day_levels)
  const impact = relation(task.impact_levels)
  const capacity = relation(task.capacity_levels)
  const dayType = relation(task.day_type_levels)

  // ----------------------------------------------------------
  // BluPrint concepts
  // ----------------------------------------------------------

  const completed = flag(task.is_completed)
  const recurring = flag(task.is_recurring)
  const hidden = flag(task.is_hidden)

  const hasNotes = exists(task.notes)

  const hasProject = exists(project)
  const hasContext = exists(context)
  const hasLocation = exists(location)

  // ----------------------------------------------------------
  // Review
  // ----------------------------------------------------------

  const review = {
    status: task.review_status,
    count: task.review_count,
    missed: task.missed_count,
    lastReviewed: task.last_reviewed_at
  }

  // ----------------------------------------------------------
  // BluPrint object
  // ----------------------------------------------------------

  return {
    ...task,

    completed,
    recurring,
    hidden,

    project,
    priority,
    status,
    context,
    focusArea,
    location,
    taskTime,
    timeOfDay,
    impact,
    capacity,
    dayType,

    hasNotes,
    hasProject,
    hasContext,
    hasLocation,

    review
  }
}

export function hydrateTasks(tasks = []) {
  return tasks.map(hydrateTask)
}